import { render, staticRenderFns } from "./botScene.vue?vue&type=template&id=ca9b378c&"
import script from "./botScene.vue?vue&type=script&lang=js&"
export * from "./botScene.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports